import axios from "axios";

import logger from "lib/logger";

type ATBStats = {
  atbAction?: boolean;
  atbError?: boolean;
};

export const reportAddToBagStats = (bagArea: string, result: ATBStats) => {
  return axios({
    data: JSON.stringify(result),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    url: `/api/metrics/add-to-bag/${bagArea}`,
  }).catch((e) => {
    logger.error("Unable to report Add To Bag stats", e);
  });
};
